<p-panel>
  @if (!loadingData && form) {
    <app-reactive-form-builder 
      (formChanges)="formChanges($event[0], $event[1])" 
      (goBack)="goBack()"
      [form]="form.formFields" 
      [serverUrl]="form.env.auxServerUrl" 
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [dropdownsFinalized]="dropdownsFinalized"
      [id]="getModel().id ?? ''"
      [request]="this.getType() === 1 ? this.tareasApi.fertilizantes.PUT : this.tareasApi.fertilizantes.POST"
      [getRequest]="this.tareasApi.fertilizantes.GET">
    </app-reactive-form-builder>
  } @else {
    <div style="display: flex; justify-content: center; align-items: center; padding: 2rem;">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
</p-panel>